import type {KpiRangeBreachSeverity} from '@hconnect/common/types'

export enum ThresholdSign {
  LessThan = 'lessThan',
  MoreThan = 'moreThan'
}

export enum ThresholdPreviewType {
  LessThan = 'lessThan',
  MoreThan = 'moreThan',
  Between = 'between'
}

export type Threshold = {
  name: string
  value: number
  severity: KpiRangeBreachSeverity
  sign?: ThresholdSign
  unit?: string
}

export type ThresholdPreview = {
  severity: KpiRangeBreachSeverity
  unit?: string
} & (
  | {
      type: ThresholdPreviewType.LessThan | ThresholdPreviewType.MoreThan
      value: number
    }
  | {
      type: ThresholdPreviewType.Between
      from: number
      to: number
    }
)
